import React, { Component } from 'react'
import './dashboard.scss'
import { Constants, ImageConstants } from '../../constants/constants'
import { getImageSource } from '../../utility/image-source'
import ClassComponent from '../class/setup-class/setup-class'
import AddUser from './add-user/add-user'
import AddSection from './add-section/add-section'
import SessionCache from '../routes/session-cache'
import Path from '../routes/routes-path'
import { Modal, ModalBody } from 'reactstrap'
import ConfirmProfile from './confirm-profile/confirm-profile'
import InviteStudents from '../class/invite-students/invite-students'
import Services from '../../../service/service'
import DownloadCertificate from './download-certificate/download-certificate'
import SchoolApi from '../../apis/school'
import ToasterComponent from '../common/cw-toaster-component/cw-toaster-component'
class Dashboard extends Component {
  state = {
    selectedClass: 'All'
  }
  data = []
  constructor(props) {
    super(props)

    let isPasswordUpdated = SessionCache.isPasswordUpdated()
    if (!isPasswordUpdated) {
      this.props.history.replace(Path.ONBOARD)
    }
    let userName = SessionCache.getName()

    this.name = userName

    let user = SessionCache.getUser()
    this.user = user
    this.state.gmcAllowed = false
    this.state.imdAllowed = false
    if (user.schoolInfo?.eventParticipated && user.schoolInfo?.eventParticipated.length) {
      let index = user.schoolInfo?.eventParticipated.findIndex(ep => {
        return ep.eventId === Constants.GMC_EVENT_ID
      })
      if (index > -1) {
        this.state.gmcAllowed = true
      }
      index = user.schoolInfo?.eventParticipated.findIndex(ep => {
        return ep.eventId === Constants.IMD_EVENT_ID
      })
      if (index > -1) {
        this.state.imdAllowed = true
      }
    }
    this.getDashboardActions()
  }

  componentDidMount() {
    // this.getTeacherCertificate()

    this.getClassDetails()

  }

  getClassDetails() {
    let payload = { limit: 100 }

    SchoolApi.getClassAndBoard(payload)
      .then(school => {
        let classes = []
        for (let i = 0; i < school.classes.length; i++) {
          classes.push({
            title: school.classes[i].name,
            value: school.classes[i].name
          })
        }

        this.setState({ classes: classes })
      })
      .catch(err => { })
  }

  assignHomeworkByFixedConcept = (selectedClass = '') => {
    let userInfo = this.user
    let classes = this.state.classes
    let classList = []
    classes.forEach(classDetail => {
      classList.push(classDetail.title)
    })

    if (selectedClass && selectedClass.class) {
      console.log('inside')
      classList = classList.filter(classItem => classItem === selectedClass.class)
    }

    console.log(classList)

    window.open(
      `/school/students/homework/assign/${userInfo.schoolInfo.schoolCode}/650aa3cdefd4fb045a339f0f?class=${classList.join(',')}`
    )
  }


  getDashboardActions() {
    let user = SessionCache.getUser()

    let isAdmin = false
    user.types.forEach(item => {
      if (!isAdmin) isAdmin = item.type == 'ADMIN'
    })

    this.data = [
      {
        title: 'Setup Classes',
        buttonText: '',
        subTitle: 'Please set up classes, so you can add teachers and students to each class.',
        step : 1,
        action: 'ADD_CLASSES',
        onCLick: this.openAddClass,
        disabled: false,
        optional: false,
        completed: false
      },
      {
        title: 'Add Teachers',
        buttonText: '',
        subTitle: 'You cannot add teachers till you have set up a class.',
        action: 'ADD_TEACHERS',
        onCLick: this.openAddTeachers,
        disabled: true,
        optional: false,
        completed: true
      }
    ]

    this.data.push({
      title: 'Add Students',
      buttonText: '',
      action: 'ADD_CLASSES',
      onCLick: this.openAddStudents,
      disabled: true,
      optional: false,
      completed: true
    })

    this.prepareDashboardList(isAdmin)
  }

  prepareDashboardList(isAdmin) {
    let user = SessionCache.getUser()
    let schoolProfileConfirmed = user.schoolInfo?.isConfirmed
    let totalSections = user.schoolInfo?.totalSections
    let studentsCount = user.schoolInfo?.totalStudents

    // if (user.schoolInfo && user.schoolInfo.schoolTempId) {
    // this.data[1].disabled = this.data[0].completed !== true

    // }

    if (isAdmin) {
      if (totalSections) {
        this.data[0].completed = true
        this.data[1].disabled = false
        this.data[2].disabled = false
      }


      // } else {
      //   if (totalSections) {
      //     if (studentsCount) {
      //       this.data[0].disabled = false
      //       this.data[0].completed = true
      //     }
      //   }
    }

    return
  }

  openAddClass = () => {
    this.props.history.push({ pathname: Path.CLASSES })
  }

  openAddTeachers = () => {
    this.props.history.push({ pathname: Path.USERS })
  }

  openAddStudents = () => {
    this.props.history.push({ pathname: Path.STUDENTS })
  }

  openAddUser = () => {
    this.setState({ showAddUser: true })
  }

  hideModal = () => {
    this.getDashboardActions()
    this.setState({
      showConfirmProfile: false,
      showAddClass: false,
      showAddUser: false,
      showAddSection: false
    })
  }

  hideSchoolProfileModal = () => {
    let user = SessionCache.getUser()
    let schoolProfileConfirmed = user.schoolInfo?.isConfirmed
    this.getDashboardActions()
    if (schoolProfileConfirmed) {
      this.setState({
        showConfirmProfile: false,
        showAddClass: true
      })
    } else {
      this.hideModal()
    }
  }

  onCloseAddSectionModal = () => {
    let user = SessionCache.getUser()
    let value = user.schoolInfo.totalSections
    if (value) {
      let sideMenuService = Services.getSideMenu()
      if (sideMenuService) sideMenuService.refreshSideMenu()
      this.setState({
        showAddClass: false,
        showAddUser: true,
        selectedIndex: 1
      })
    } else {
      this.hideModal()
    }
  }

  openAddSection = () => {
    this.setState({ showAddSection: true })
  }

  hideTeacherModal = value => {
    let user = SessionCache.getUser()
    if (value) {
      user.schoolInfo.totalSections = 1
      SessionCache.setUser(user)
      let sideMenuService = Services.getSideMenu()
      if (sideMenuService) sideMenuService.refreshSideMenu()
      this.setState({
        showAddClass: false,
        showAddUser: true,
        selectedIndex: 2
      })
    } else {
      this.hideModal()
    }
  }

  openConfirmProfile = () => {
    this.setState({ showConfirmProfile: true })
  }

  // openAddClass = () => {
  //   this.setState({ showAddClass: true })
  // }

  openAddUser = () => {
    this.setState({ showAddUser: true })
  }

  openInviteStudents = () => {
    this.setState({ showInviteStudents: true })
  }

  openInviteTeachers = () => {
    this.setState({ showInviteTeachers: true })
  }

  hideModal = (success) => {
    if (success === true) this.showToaster('info', 'Message shared successfully on Whatsapp')
    this.getDashboardActions()
    this.setState({
      showConfirmProfile: false,
      showAddClass: false,
      showAddUser: false,
      showAddSection: false,
      showInviteStudents: false,
      showInviteTeachers: false
    })
  }

  showToaster(type, message) {
    this.setState(
      {
        showToaster: true,
        toasterMessage: message,
        toasterType: type
      },
      () => {
        setTimeout(() => {
          this.hideToaster()
        }, 3000)
      }
    )
  }

  hideToaster() {
    this.setState({
      showToaster: false
    })
  }

  openAddSection = () => {
    // this.setState({ showAddSection: true })
  }

  hideTeacherModal = value => {
    if (value) {
      let user = SessionCache.getUser()
      user.schoolInfo.totalTeachers = 2
      SessionCache.setUser(user)
      let sideMenuService = Services.getSideMenu()
      if (sideMenuService) sideMenuService.refreshSideMenu()
    }
    this.hideModal()
  }

  renderSetupClass() {
    return (
      <Modal
        className='cw-custom-modal-right'
        isOpen={true}
        toggle={this.hideModal}
        size={'lg'}
      >
        <ModalBody>
          <div className='setup-class-dashboard'>
            <div className='abs-image'>
              <img
                className='cursor-pointer header-image'
                src={getImageSource(ImageConstants.HEADER1)}
              />
            </div>

            <div className='pt-4 my-auto'>
              <span className='step-title'>STEP 2</span>
              <span className='float-right'>
                <img
                  className='close-icon cursor-pointer'
                  src={getImageSource(ImageConstants.CROSS)}
                  onClick={this.hideModal}
                />
              </span>
            </div>
            <div className='pt-4 header-title'>ADD SECTIONS & TEACHERS</div>

            <ClassComponent
              show={this.state.showAddClass}
              size='lg'
              onClose={this.hideTeacherModal.bind(this)}
              disableAddStudent={true}
              modalType='RIGHT'
            />
          </div>
        </ModalBody>
      </Modal>
    )
  }

  onClickList(item, index) {
    this.setState({ selectedIndex: index, selectedItem: item }, () => {
      if (!item.disabled) {
        item.onCLick()
      } else {
      }
    })
  }

  onContinue = _ => {
    this.hideModal()
  }

  onSelectClass = title => {
    this.setState(
      {
        selectedClass: title || 'All'
      },
      _ => {
        const {
          showDetails,
          showEvaluationReport,
          showPerformanceReport
        } = this.state
        const payload = {}
        if (title) payload.class = title
        if (showDetails) {
          this.imdStudents.setSelectedClass(payload)
        } else if (showEvaluationReport) {
          this.evaluationReport.getEvaluationReport(payload)
        } else if (showPerformanceReport) {
          this.performanceReport.getIMDStudentPerformanceList(payload)
        } else {
          this.assessmentChart.getIMDReport(payload)
          this.assessmentChart.getIMDPerformaceReport(payload)
          this.assessmentChart.getIMDNationalAverage(payload)
        }
      }
    )
  }

  viewDetails = _ => {
    this.setState({
      showDownloadScreen: true
    })
  }

  goBack = _ => {
    this.setState({
      showDownloadScreen: false,
    })
  }
  // downloadTeacherCertificate = _ => {
  //   window.open(this.state.teacherCertificate, "_blank")
  // }

  // getTeacherCertificate = _ => {
  //   const payload = {eventId: this.state.gmcAllowed ? Constants.GMC_EVENT_ID : Constants.IMD_EVENT_ID}
  //   SchoolApi.getTeacherCertificate(payload).then((response) => {
  //     this.setState({
  //       teacherCertificate: response.url
  //     })
  //   }).catch((err) => {
  //     console.log(err)
  //   })
  // }

  render() {
    const { showDownloadScreen, isDownloadLoading } = this.state;
    return (
      <div className='dashboard'>
        {/* <div className='mb-5 cursor-pointer' onClick={_ => this.props.history.push({ pathname: Path.STANDARD_HOMEWORK, showList: true })}> */}
        {/* <div className='mb-5 cursor-pointer' onClick={_ => this.assignHomeworkByFixedConcept()}>
          <img
            className='ad-banner'
            src={getImageSource(ImageConstants.SCHOOL_PORTAL_MSF_BANNER)}
          />
        </div> */}
        {!showDownloadScreen && <>
          <div>
            <div className='personal-details'>
              <span className='screen-title'>Hello {this.name || ''}</span>
              {/* {teacherCertificate &&
              <span className='certificate-download'>
                <img
                  className='certificate'
                  src={getImageSource(ImageConstants.FLUENT_CERTIFICATE)}
                />
                Certificate of Appreciation{' '}
                <button onClick={this.downloadTeacherCertificate} className='btn-certificate-download'>Download</button>
              </span>
            } */}
            </div>

            <div className='pt-2'>
              <span className=''>Please complete setting up your school</span>
            </div>
          </div>
          <div className='pt-4'>
            {this.data.map((item, index) => (
              <div
                className={`cw-plain-card cw-plain-card-wrapper mt-4 ${!item.disabled && !item.completed ? 'card-focus' : ''
                  }`}
                key={index}
              >
                <div
                  className='row cursor-pointer'
                  onClick={() => this.onClickList(item, index)}
                >
                  <div className='col-1 my-auto'>
                    {/* {item.completed ? (
                    <span>
                      {' '}
                      <img
                        className='confirmed'
                        src={getImageSource(ImageConstants.TICK)}
                      />{' '}
                    </span>
                  ) : (
                    ''
                  )} */}
                    <span
                      className={`dashboard-sl-number text-center my-auto ${item.disabled ? 'in-active' : 'active'
                        }`}
                    >
                      {index + 1}
                    </span>
                  </div>

                  <div className={`col-9 my-auto `}>
                    <span
                      className={`${item.disabled ? 'in-active-card-text' : 'card-text'
                        }`}
                    >
                      {item.title}
                    </span>
                    {item.step == 1 && item.completed == false ? <div>{item.subTitle}</div> : ''}
                    <div className={`${item.disabled ? 'in-active-card-subtext' : 'card-text'}`}>{(item.action == 'ADD_TEACHERS' && item.disabled == true) ? item.subTitle : '' }</div>
                    {item.optional ? (
                      <span className='optional-text px-2'>OPTIONAL</span>
                    ) : (
                      ''
                    )}
                    {item.note ? (
                      <div
                        className={`${item.disabled ? 'in-active-note-text' : 'note-text'
                          }`}
                      >
                        Note :{' '}
                        <span>
                          {' '}
                          <strong>{item.note}</strong>
                        </span>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>

                  <div className='col-2 text-right my-auto'>
                    {!item.disabled ? (
                      item.completed ? (
                        <img
                          className='arrow-gray cursor-pointer'
                          src={getImageSource(ImageConstants.RIGHT_ARROW)}
                          onClick={item.onCLick}
                        />
                      ) : (
                        <div className='cw-button-sm py-2' onClick={item.onCLick}>
                          <img
                            className='arrow'
                            src={getImageSource(ImageConstants.RIGHT_ARROW_WHITE)}
                          />
                        </div>
                      )
                    ) : (
                      <img
                        className='arrow-gray'
                        src={getImageSource(ImageConstants.RIGHT_ARROW_GRAY)}
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>}
        {showDownloadScreen && <DownloadCertificate goBack={this.goBack} />}
        {this.state.showConfirmProfile ? (
          <ConfirmProfile
            step='STEP 1'
            size='lg'
            type='USER'
            title='ADD NEW USER'
            onClose={this.hideModal}
            onSave={this.hideSchoolProfileModal}
          />
        ) : (
          ''
        )}
        {this.state.showAddClass && this.renderSetupClass()}
        {this.state.showAddUser ? (
          <AddUser
            show={this.state.showAddUser}
            step={this.state.selectedIndex + 1}
            selectedItem={this.state.selectedItem}
            size='lg'
            type='TEACHER'
            title='ADD NEW TEACHER'
            onClose={this.hideModal}
          />
        ) : (
          ''
        )}
        {this.state.showAddSection ? (
          <AddSection
            show={this.state.showAddSection}
            step={this.state.selectedIndex + 1}
            selectedItem={this.state.selectedItem}
            size='lg'
            onClose={this.onCloseAddSectionModal}
          />
        ) : (
          ''
        )}

        {this.state.showInviteStudents && (
          <InviteStudents
            onClose={this.hideModal}
          />
        )}
        {/* {
          this.state.showInviteTeachers && (
            <InviteParticipants
              step='STEP 2'
              size='lg'
              type={2}
              onClose={this.hideModal}
              onContinue={this.onContinue}
            />
          )
        } */}
        {this.state.showToaster ? (
          <div className='custom-toaster-modal'>
            <ToasterComponent message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" />
          </div>
        ) : (
          ''
        )}
        {isDownloadLoading && (
          <Modal className="cw-custom-modal" isOpen={isDownloadLoading} size={'md'}>

            <ModalBody >
              <div className="add-admin">
                <div className="header-text text-center">
                  <span>Downloading Certificate</span>
                </div>
                <div className='row px-5 py-5 margin-auto'>
                  <img
                    className='loader-icn'
                    src={getImageSource(
                      ImageConstants.PRE_LOADER_GIF
                    )}
                  />
                </div>
              </div>
            </ModalBody>

          </Modal >
        )}
      </div>
    )
  }
}

export default Dashboard
